import { useQuery } from "react-query";
import { getAccountAgreement } from "../../../api/services";

export const useAgreementDetails = (
  accountNumber: string,
  agreementId: string,
) => {
  return useQuery(
    ["accounts/agreement", { accountNumber, agreementId }],
    getAccountAgreement,
    {
      enabled: !!accountNumber && !!agreementId,
    },
  );
};
